import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useEffect, Fragment } from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@ninja/icons/web';
import { Collapsible, CollapsibleButton, CollapsiblePanel } from './Collapsible2.js';
import variants from './Disclosure3.js';

const Disclosures = ({ items, className, variant = 'primary', openItems, onToggle }) => {
    const [openIndex, setOpenIndex] = useState([]);
    useEffect(() => {
        setOpenIndex(openItems);
    }, [openItems]);
    const toggleDisclosure = (itemKey) => {
        var _a, _b;
        let newOpenItems;
        if (openIndex === null || openIndex === void 0 ? void 0 : openIndex.includes(itemKey)) {
            newOpenItems = (_a = openIndex === null || openIndex === void 0 ? void 0 : openIndex.filter((o) => o !== itemKey)) !== null && _a !== void 0 ? _a : [];
        }
        else {
            newOpenItems = (_b = openIndex === null || openIndex === void 0 ? void 0 : openIndex.concat([itemKey])) !== null && _b !== void 0 ? _b : [itemKey];
        }
        setOpenIndex(newOpenItems);
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(newOpenItems, itemKey);
    };
    const isOpen = (index) => { var _a; return (_a = (openItems !== null && openItems !== void 0 ? openItems : openIndex)) === null || _a === void 0 ? void 0 : _a.includes(index); };
    return (jsx("div", { className: variants[variant].container(className), children: items.map((item, i) => {
            var _a;
            const itemKey = (_a = item.key) !== null && _a !== void 0 ? _a : i;
            return (jsxs(Fragment, { children: [jsx(Collapsible, { open: isOpen(itemKey), onToggle: () => toggleDisclosure(itemKey), children: jsxs("div", { className: variants[variant].buttonContainer, children: [jsx(CollapsibleButton, { children: jsxs("div", { className: variants[variant].button, children: [jsx("span", { children: item.header }), jsx("div", { className: variants[variant].arrow, children: isOpen(itemKey) ? jsx(ArrowUpIcon, {}) : jsx(ArrowDownIcon, {}) })] }) }), jsx(CollapsiblePanel, { children: jsx("div", { className: variants[variant].body, children: item.body }) })] }) }), jsx("div", { className: variants[variant].separator })] }, itemKey));
        }) }));
};

export { Disclosures };
